import { Component } from 'solid-js';
import { Router, Route, useLocation, useParams } from '@solidjs/router';
import { QueryClient, QueryClientProvider } from '@tanstack/solid-query';
import { AuthProvider } from './stores/AuthContext';
import ProtectedRoute from './components/ui/ProtectedRoute';
import Layout from './components/layouts/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clicks from './pages/Clicks';
import Conversions from './pages/Conversions';
import Report from './pages/Report';
import UserReport from './pages/UserReport';
import { config } from './config/environment';

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const LayoutWrapper: Component = () => {
  const location = useLocation();
  const params = useParams();

  // Check if current path is user report
  const isUserReport = () => location.pathname.startsWith('/report/user/');

  return (
    <ProtectedRoute>
      <Layout>
        {/* Render different content based on route */}
        {location.pathname === '/' || location.pathname === '/dashboard' ? (
          <Dashboard />
        ) : location.pathname === '/clicks' ? (
          <Clicks />
        ) : location.pathname === '/conversions' ? (
          <Conversions />
        ) : location.pathname === '/report' ? (
          <Report />
        ) : isUserReport() && config.features.enableUserDetails ? (
          <UserReport />
        ) : (
          <Dashboard />
        )}
      </Layout>
    </ProtectedRoute>
  );
};

const App: Component = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Route path="/login" component={Login} />
          {/* Layout wraps all protected routes - stays mounted during navigation */}
          <Route path="*" component={LayoutWrapper} />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
